<div class="container">
  <!-- <app-template
    [title]="'Print Invoice'"
    style="z-index: -3; padding-bottom: 500px"
  > -->
  <div class="inner" style="padding: 20px">
    <button
      mat-raised-button
      color="primary"
      (click)="printResult()"
      style="margin-right: 10px"
    >
      Print
    </button>
    <button (click)="back()" class="create" mat-raised-button color="primary">
      Back
    </button>

    <div *ngIf="recLoad" style="margin-top: 50px" class="spinner">
      <mat-spinner></mat-spinner>
    </div>
    <!-- <div *ngIf="!recLoad" class="return" id="receipt" style=" margin-left: 50px; margin-bottom: 100px;margin-top: 70px; position: relative; z-index: 2;" [innerHTML]="receipt"></div> -->
    <div class="invoice" style="width: 100%">
      <div *ngIf="reLoad" style="width: 200px; margin: 100px auto">
        <mat-spinner></mat-spinner>
      </div>
      <div id="receipt" class="all" style="width: 400px" *ngIf="!reLoad">
        <div class="top" style="font-size: 16px">
          Everight Diagnostic & Laboratory Service LTD 
              <!-- Abuja Branch 2 Fez Street; 08155515100, 08108484623 -->
              {{ appversion.branch.name }} {{ appversion.branch.address }} {{ appversion.branch.contact }}
        </div>
        <div class="name" style="font-size: 23px; font-weight: 700">
          Cash Invoice
        </div>
        <div class="body">
          <table>
            <tr style="font-size: 20px">
              <td style="border: 0px; padding: 0px; font-size: 16px">
                <b class="var">Bill No.</b>
              </td>
              <td style="border: 0px; padding: 0px; font-size: 16px">
                <span class="value">{{ detail!.bill_no }}</span>
              </td>
            </tr>
            <tr>
              <td style="border: 0px; padding: 0px; font-size: 16px">
                <b class="var">Name</b>
              </td>
              <td style="border: 0px; padding: 0px; font-size: 16px">
                <span class="value">{{ detail!.patientName }}</span>
              </td>
            </tr>
            <tr>
              <td style="border: 0px; padding: 0px; font-size: 16px">
                <b class="var">Date and Time</b>
              </td>
              <td style="border: 0px; padding: 0px; font-size: 16px">
                <span class="value">{{ detail!.billDate | date }}</span>
              </td>
            </tr>
            <tr>
              <td style="border: 0px; padding: 0px; font-size: 16px">
                <b class="var">Date of Birth</b>
              </td>
              <td style="border: 0px; padding: 0px; font-size: 16px">
                <span class="value">{{ detail!.date_of_birth | date }}</span>
              </td>
            </tr>
            <tr>
              <td style="border: 0px; padding: 0px; font-size: 16px">
                <b class="var">DOB/Gender</b>
              </td>
              <td style="border: 0px; padding: 0px; font-size: 16px">
                <span class="value"
                  >{{ detail3 }}/{{ detail!.patient_gender }}</span
                >
              </td>
            </tr>
            <tr>
              <td style="border: 0px; padding: 0px; font-size: 16px">
                <b class="var">Mobile No</b>
              </td>
              <td style="border: 0px; padding: 0px; font-size: 16px">
                <span class="value">{{ detail!.patient_phone }}</span>
              </td>
            </tr>
            <tr>
              <td style="border: 0px; padding: 0px; font-size: 16px">
                <b class="var">Ref DR.</b>
              </td>
              <td style="border: 0px; padding: 0px; font-size: 16px">
                <span class="value">{{ detail!.referred_doctor }}</span>
              </td>
            </tr>
            <tr>
              <td style="border: 0px; padding: 0px; font-size: 16px">
                <b class="var">The sum of</b>
              </td>
              <td style="border: 0px; padding: 0px; font-size: 16px">
                <span class="value">Zero Naira Only</span>
              </td>
            </tr>
          </table>
          Being Payment for
          <hr />
          <div *ngFor="let service of detail.encounterServices">
            <div>{{ service!.service_name }} ({{ service!.sample_id }})</div>
          </div>
          <table style="font-size: 20px">
            <tr>
              <td style="border: 0px; padding: 0px; font-size: 16px">
                <b class="var">Bill Amount</b>
              </td>
              <td style="border: 0px; padding: 0px; font-size: 16px">
                <span class="value">{{
                  detail!.totalAmount | currency : "&#8358;"
                }}</span>
              </td>
            </tr>
            <tr>
              <td style="border: 0px; padding: 0px; font-size: 16px">
                <b class="var">Refund Amount</b>
              </td>
              <td style="border: 0px; padding: 0px; font-size: 16px">
                <span class="value">{{
                  detail!.refundAmount | currency : "&#8358;"
                }}</span>
              </td>
            </tr>
            <tr>
              <td style="border: 0px; padding: 0px; font-size: 16px">
                <b class="var">Advance Amount</b>
              </td>
              <td style="border: 0px; padding: 0px; font-size: 16px">
                <span class="value">0.00</span>
              </td>
            </tr>
            <tr>
              <td style="border: 0px; padding: 0px; font-size: 16px">
                <b class="var">Received Amount</b>
              </td>
              <td style="border: 0px; padding: 0px; font-size: 16px">
                <span class="value">{{
                  detail!.amountPaid | currency : "&#8358;"
                }}</span>
              </td>
            </tr>
            <tr>
              <td style="border: 0px; padding: 0px; font-size: 16px">
                <b class="var">Balance Amount</b>
              </td>
              <td style="border: 0px; padding: 0px; font-size: 16px">
                <span class="value">{{
                  detail!.amountOutstanding | currency : "&#8358;"
                }}</span>
              </td>
            </tr>
            <tr>
              <td style="border: 0px; padding: 0px; font-size: 16px">
                <b class="var" style="font-weight: 700">Issued By</b>
              </td>
              <td style="border: 0px; padding: 0px; font-size: 16px">
                <span class="value">{{ name }}</span>
              </td>
            </tr>
          </table>
          <div style="margin-top: 20px">Thank you</div>
          <div>
            Please bring your receipt on the date of result collection The
            receipt is only valid with the stamp & signature of the cashier.
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </app-template> -->
</div>
